import { constants } from 'src/components/player/src/constants/playerConstants';
import { setSessionStorage } from 'src/components/player/src/utils/Utils';
import { Countrylist } from 'src/services/responseTypes/singleLaunchResponse';
import { mixpanelObject } from 'src/utils/analytics';
import { clearCtaEventsProperty } from 'src/utils/analytics/mixpanel/mixpanelHelper';
import { getAutomaticAgeRating } from 'src/utils/VideoPlayerUtils/Utils';

import { playerCtaEvent } from '../../../../utils/analytics/mixpanel/mixpanelEventsHelper';
import { gotoLogin } from '../playerCallbacks';
import {
  MIXPANEL_ELEMENT,
  MIXPANEL_LOGIN,
  MIXPANEL_BUTTON_TYPE,
  MIXPANEL_EVENTS_PLAYER_CTAS
} from '../../../../utils/analytics/mixpanel/mixpanelConstants';
import { REDIRECT_URL_TO_CONSUMPTION } from 'src/utils/constants/localStorageConstants';

type AdultPopupProps = {
  popupProps: any;
  countryList: Countrylist | undefined;
  closePopUp: any;
};
const AdultPopup = ({
  popupProps,
  countryList,
  closePopUp
}: AdultPopupProps) => {
  const { messages = {} } = window.translationsAndConfigs || {};
  const mandateAge = countryList ? getAutomaticAgeRating(countryList) : null;
  const { isAdvertisementAuthenticated } = popupProps;
  const getErrorText = () => {
    if (Object.keys(messages).length && !mandateAge) {
      if (isAdvertisementAuthenticated) {
        return messages.Player_Msg_LoginWatchFree;
      } else {
        return messages.Player_Msg_AVOD_adult_18towatchvideo;
      }
    } else {
      const markUp = (
        <div>
          <span>
            {messages.parentalControl_player_blocker_msg.replace(
              '{{age}}',
              mandateAge
            )}
          </span>
          <div className="error-msg-title">{messages.Existing_Users}</div>
        </div>
      );
      return markUp;
    }
  };

  const loginHandler = () => {
    setSessionStorage(REDIRECT_URL_TO_CONSUMPTION, window.location.pathname);
    closePopUp();
    clearCtaEventsProperty(mixpanelObject);
    mixpanelObject[MIXPANEL_ELEMENT] =
      mixpanelObject.getProperty(MIXPANEL_LOGIN);
    mixpanelObject[MIXPANEL_BUTTON_TYPE] = mixpanelObject.getProperty(
      MIXPANEL_EVENTS_PLAYER_CTAS
    );
    playerCtaEvent();
    gotoLogin();
  };

  return (
    <div className="main-container" id="main-container">
      <div className="adult-content-error-msg">
        <div className="adult-content-error-text">{getErrorText()}</div>
        <div className="login-text" id="login" onClick={loginHandler}>
          {messages?.Login_Button}
        </div>
      </div>
    </div>
  );
};

export default AdultPopup;
